import gql from 'graphql-tag';

export const CREATE_STATIONARY_LOG = gql`
  mutation createStationoryLogs($createStationoryLogInputs: [CreateStationoryLogInput!]!) {
    createStationoryLogs(createStationoryLogInputs: $createStationoryLogInputs) {
      id
      stationoryId
      date
      stationoryData {
        id
        stationoryName
        stationoryCode
      }
      openingStock
      closingStock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;


export const UPDATE_STATIONARY_LOG = gql`
  mutation updateStationoryLog($updateStationoryLogInput: UpdateStationoryLogInput!) {
    updateStationoryLog(updateStationoryLogInput: $updateStationoryLogInput) {
      id
      stationoryId
      date
      stationoryData {
        id
        stationoryName
        stationoryCode
      }
      openingStock
      closingStock
    }
  }
`;
